import type { BrandConfig } from './types';
import gxzsImage from '@/assets/images/gxzs.png';

export const gxzsConfig: BrandConfig = {
  key: 'gxzs',
  isDefault: false,
  subdomain: 'aifilm.gxzs',
  logo: '/brands/amai/logo.png',
  title: 'GXZS-重庆工影智谷影视工业产业中心',
  siteName: '',
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: 'AME平台付费服务协议',
    productNameKey: 'payment.ameProductName',
  },
  agreementTabs: [
    { key: 'user-agreement', label: 'AME平台付费协议', labelKey: 'agreement.tabAmePayment' },
    { key: 'ricegrain-rules', label: '米粒值规则说明', labelKey: 'agreement.tabRiceGrain' },
    { key: 'privacy-policy', label: '用户协议及隐私政策', labelKey: 'agreement.tabPrivacy' },
    { key: 'enterprise-service-agreement', label: '企业服务协议', labelKey: 'agreement.tabEnterprise' },
  ],
  logoDisplay: {
    mode: 'image',
    image: gxzsImage,
    imageStyle: { width: 'auto', height: '100%' },
    showGlow: true,
  },
  logoClickable: false,
  // 调试：右下角「模拟 gxzs」按钮（仅开发/测试环境渲染），验证 gxzs 站点形态
  showBrandDebugSwitch: true,
  // 站点形态：隐藏侧边栏「首页」与「邀请好友」入口、隐藏「AI创作」区块，默认落地任务大厅 /tasks
  hiddenSidebarItems: ['home', 'invite'],
  hiddenSidebarSections: ['creation'],
  defaultRoute: '/tasks',
  // 根路径展示全屏欢迎落地页（同 amai 主站 '/'），「立即体验」按钮跳 /tasks
  rootLanding: 'welcome',
  // 独立运营：认证失效弹站内登录弹窗（LoginModal），不跳转 ame-film 外部登录页
  useLoginModal: true,
  // 任务大厅始终用前端占位数据（登录后也不请求接口）
  useTaskHallMockData: true,
  // ICP 备案：邀请好友下方可点击标签，跳工信部备案系统
  icpRecord: {
    text: '渝ICP备2026007983号-1',
    url: 'https://beian.miit.gov.cn/#/Integrated/index',
  },
};
